<template>
  <div>
    <md-card>
      <!-- 卡片-主体 -->
      <md-card-content>
        <!-- 卡片-主体-表单-表格数据筛选 -->
        <div class="md-layout card-form" style="max-width: 400px;">
          <!-- 表单-选择框-公司 -->
          <div class="md-layout-item md-size-75 left-layout-item md-xsmall-size-50">
            <md-field>
              <label>{{$I18n("company")}}</label>
              <md-select v-model="formData.comp_id">
                <md-option 
                  v-for="item in companys" 
                  :value="item.comp_id" 
                  :key="item.comp_id">
                  {{item.comp_short_name ?item.comp_short_name : item.comp_name}}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-25">
            <md-button class= "left-icon md-info" @click="form_search">
              <md-icon>search</md-icon>
              {{$I18n("search")}}
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <md-card>
      <!-- 卡片-主体 -->
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item">
            <add-button @click="() => table_addItem()">{{$I18n("add_template")}}</add-button>
          </div>
        </div>
        <md-table v-model="tableData">
          <md-table-row slot="md-table-row" slot-scope="{ item }" >
            <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
            <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('language')">{{ item.lang_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('update_date')">{{ item.update_time }}</md-table-cell>
            <md-table-cell :md-label="$I18n('create_time')">{{ item.created_time }}</md-table-cell>
            <md-table-cell :md-label="$I18n('operate')"  class="button-box">
              <md-button @click="table_editItem(item)" class="md-just-icon md-round md-info left-icon">
                <md-icon>edit</md-icon>
              </md-button >
              <md-button @click="table_deleteItem(item)" class="md-just-icon md-round md-danger md-info" >
                <md-icon>close</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
          <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
        </md-table>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="pageNo"/>
      </md-card-content>
    </md-card>
    <!-- 弹窗 -->
    <simple-modal 
      ref        = "modal"
      :title     = "modalTitle"
      :right     = "openModalType!=='delete'"
      :large     = "openModalType==='import'"
      :submitBtn = "openModalType!=='import'"
      @submit    = "modal_submit"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", modalData.Form.name)}}</div>
        <!-- 修改/添加弹窗 -->
        <div class="md-layout" v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <md-field slot="date" :class="{'md-error' : modalData.Error.validity_time}">
              <el-date-picker
                class="md-date-form-item"
                align="left"
                v-model="modalData.Form.validity_time"
                prefixIcon="no"
                value-format="yyyy-MM-dd HH:mm:SS"
                :placeholder="$I18n('validity_time')"
                :end-placeholder="$I18n('end')">
              </el-date-picker>
              <md-icon :style="{'margin-right': 0}" v-if="modalData.Error.validity_time">clear</md-icon>
            </md-field>
          </common-form-item>
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
// import {  } from "@/common/tools.js";
import { timestampToString1000, FormClass } from "@/common/tools.js";
export default {
  data() {
    return {
      formData  : {comp_id: this.UserInfo.comp_id},
      searchData: {comp_id: this.UserInfo.comp_id},
      companys : [],

      // Table 原始数据 (翻页)
      tableInitData: [],
      pageNo   : 1,
      total    : 0,

      // 每页的数量(统一)
      pageSize: 10,
      // 弹窗相关
      openModal     : false, // 是否打开弹窗
      openModalType : "",    // 弹窗类型
      modalTitle    : "",    // 弹窗标题
      // 弹窗表单相关
      modalData : new FormClass({
        "comp_id" : this.UserInfo.comp_id,
        "type"    : 1,
        "lang"    : "zh-CN",
        "sub_lang": "zh-CN",
        "name"    : "",
        "title"   : "", 
        "body"    : "",
      }, {
        "comp_id": "required",
        "type"   : "required",
        "lang"   : (value, formValue) => {
          if(formValue.sub_lang === "others"){
            return !value;
          } else {
            return !formValue.sub_lang;
          }
        },
        "name"   : "required",
        "title"  : "required",
        "body"   : "required",
      }),
      // 弹窗表单报错相关
      error: {},
    };
  },
  watch: {
    pageNo(){
      this.api_getPageData();
    },
  },
  computed:{
    // 表格数据处理
    tableData(){
      return [...this.tableInitData]
        .splice((this.pageNo-1) * this.pageSize, this.pageSize)
        .map(item => {
          let lang_name = "";
          switch (item.lang) {
            case "en":
              lang_name = "en(" + this.$I18n("en") + ")";
              break;
            case "zh-TW" :
              lang_name = "zh-TW(" + this.$I18n("zh-TW") + ")";
              break;
            case "zh-CN":
              lang_name = "zh-CN(" + this.$I18n("zh-CN") + ")";
              break;
            default :
              lang_name = item.lang;
              break;
          }
          return {
            ...item,
            lang_name,
            update_time: timestampToString1000(item.gmt_update),
            created_time: timestampToString1000(item.gmt_create),
            type_name: this.$I18n(this.$Param.noticeTempType.getName(item.type)),
            sub_lang : ["en", "zh-CN", "zh-TW"].includes(item.lang) ?item.lang :"others",
          }
        })
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("company"),
          keys    : "comp_id",
          type    : "select",
          options : this.companys.map(i => {
            return {
              id  :i.comp_id,
              name:i.comp_name,
            }
          }),
          class   : "md-layout-item md-size-100",
        }, {
          label   : this.$I18n("type"),
          keys    : "type",
          type    : "select",
          options : this.$Param.noticeTempType.map(i => {
            return {
              id  : i.id,
              name: this.$I18n(i.name),
            }
          }),
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("name"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("lang"),
          keys    : "sub_lang",
          type    : "select",
          options : ["en", "zh-CN", "zh-TW", "others"].map(i => {
            return {
              id  : i,
              name: i === "others" ?this.$I18n("other_lang") :this.$I18n(i),
            }
          }),
          required: true,
          check   : true,
          class   : "md-layout-item md-size-50" //+ (this.modalData.Form.sub_lang === 'others' ?"md-size-50" :"md-size-100"),
        },{
          label   : this.$I18n("lang"),
          keys    : "lang",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-50",
          hide    : this.modalData.Form.sub_lang !== "others",
        },{
          label   : this.$I18n("title"),
          keys    : "title",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("body"),
          keys    : "body",
          type    : "textarea",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-100",
        }
      ]
    },
  },
  mounted(){
    this.$api.getCompanyList({})
      .then(this.$Then(res => {
        this.companys = res.data;
        if(res.data.length === 0){
          return
        }
        this.api_getPageData();
      }))
      .catch(this.$Catch())
  },
  methods: {
    // 查询
    form_search() {
      this.searchData.comp_id = this.formData.comp_id;
      this.modalData.SetInit(this.searchData.comp_id, "comp_id");
      this.pageNo = 1;
      this.api_getPageData();
    },
    api_getPageData() {
      this.$api.getUserNoticeTemplate({
        ...this.searchData,
        page_no:   this.pageNo,
        page_size: this.pageSize,
      })
      .then(this.$Then(res => {
        this.tableInitData = res.data;
        this.total = res.count;
      }))
      .catch(this.$Catch(this.$I18n("get_error")), () => {
        this.tableInitData = [];
        this.total = 0;
      })
    },
    // 添加
    table_addItem(){
      this.modalData.Reset();
      this.openModalType = "add";
      this.modalTitle = this.$I18n("add_template");
      this.$refs.modal.open();
    },
    // 修改
    table_editItem(item){
      this.modalData.Update(item);
      this.openModalType = "edit";
      this.modalTitle = this.$I18n("edit_template");
      this.$refs.modal.open();
    },
    // 删除
    table_deleteItem(item){
      this.modalData.Update(item);
      this.openModalType = "delete";
      this.modalTitle = this.$I18n("del_template");
      this.$refs.modal.open();
    },
    modal_submit(){
      if(this.openModalType === "delete"){ // 删除
        return this.$api.delUserNoticeTemplate({...this.modalData.Form,})
          .then(this.$Then(() => {
            this.$refs.modal.close();
            this.api_getPageData();
            this.$successMsg(this.$I18n("delete_success"))
          }))
          .catch(this.$Catch(this.$I18n("delete_fail")))
      }
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }
      if(this.modalData.Form.sub_lang !== "others"){
        this.modalData.Form.lang = this.modalData.Form.sub_lang;
      }
      if(this.openModalType === "add"){
        this.$api.addUserNoticeTemplate({...this.modalData.Form,})
          .then(this.$Then(() => {
            this.$refs.modal.close();
            this.api_getPageData();
            this.$successMsg(this.$I18n("add_success"))
          }))
          .catch(this.$Catch(this.$I18n("add_fail")))
      } else if (this.openModalType === "edit"){
        this.$api.updateUserNoticeTemplate({...this.modalData.Form,})
          .then(this.$Then(() => {
            this.$refs.modal.close();
            this.api_getPageData();
            this.$successMsg(this.$I18n("edit_success"))
          }))
          .catch(this.$Catch(this.$I18n("edit_fail")))
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .left-layout{
    padding-left: 0;
  }
  .right-layout{
    padding-right: 0;
  }
  .md-card-only-title{
    margin: 0;
    box-shadow: none;
    text-align: left;
    position: relative;
    top: -12px;
    left: -20px;
  }
  .md-card-only-title .title{
    text-align:left !important;
  }
  .total-page{
    width: 30%;
    display: inline-block;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-right: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>